import { OptionsViewModel } from '@models/common.models';

export interface DocumentViewModel {
  id: number;
  customerId: number;
  contractId: number;
  fileName: string;
  key: string;
  createdDate?: Date;
  deleteDate?: Date;
  edocsType?: OptionsViewModel;
  documentType?: OptionsViewModel;
}
export interface FileViewModel {
  file: File;
  edocsTypeId?: number;
  documentTypeId?: number;
}

export enum DocumentTypes {
  Liability = 1,
  WorkersComp = 2,
  StateLicense = 3
}

export const DocumentsRequiringExpiration = [
  DocumentTypes.Liability,
  DocumentTypes.WorkersComp,
  DocumentTypes.StateLicense
];

export const VendorDocumentColumn = {
  1: 'liabilityExpiration',
  2: 'sdiExpiration',
  3: 'licenseExpiration'
};

export const VendorDocumentNormalized = {
  1: 'Liability Insurance Certificate',
  2: `Worker's Comp Certificate`,
  3: `Contractor's State License`,
  4: 'Background Check',
  5: 'W9',
  6: 'W9 Verification',
  7: 'Completed Agreement'
};



// WEBPACK FOOTER //
// ./src/_models/Document.ts